import React, { useState } from 'react';
import { Icon } from '../core/Icon.jsx';
import { IconButton } from '../core/IconButton.jsx';

/** Text input. type="password" gets a visibility toggle automatically. */
export function Input({ type = 'text', icon, error = false, className = '', style, ...rest }) {
  const [show, setShow] = useState(false);
  const isPassword = type === 'password';
  const trailing = isPassword;
  return (
    <span
      className={`bjl-input-wrap ${icon ? 'bjl-input-wrap--icon' : ''} ${trailing ? 'bjl-input-wrap--trailing' : ''} ${className}`}
      style={style}
    >
      {icon ? <Icon name={icon} className="bjl-input__icon" /> : null}
      <input className={`bjl-input ${error ? 'is-error' : ''}`} type={isPassword && show ? 'text' : type} {...rest} />
      {isPassword ? (
        <span className="bjl-input__trailing">
          <IconButton
            size="sm"
            icon={show ? 'visibility_off' : 'visibility'}
            label={show ? '隐藏密码' : '显示密码'}
            onClick={() => setShow(!show)}
            type="button"
          />
        </span>
      ) : null}
    </span>
  );
}
